import manifest from "../../static/favicons/manifest.json"

// host -> filename, generated by scripts/cache-favicons.mjs. Extensions vary
// (.svg/.png/.ico/.jpg) because each site is cached in whatever format it
// actually serves, so the exact filename has to be looked up, not guessed.
const CACHED = manifest as Record<string, string>

/** Build-time cached favicon path for a host, or null if it was never cached. */
export const cachedFaviconPath = (host: string): string | null =>
  CACHED[host] ? `/favicons/${CACHED[host]}` : null
